import React from 'react';
import Navbar from './Navbar'; // 引入 Navbar 组件
import './Layout.css';

function Layout({ children, allColumns, visibleColumns, onColumnSettingsSubmit }) {
    return (
        <div className="layout-container">
            <Navbar
                allColumns={allColumns}
                visibleColumns={visibleColumns}
                onColumnSettingsSubmit={onColumnSettingsSubmit}
            />
            <div className="main-content">{children}</div>
        </div>
    );
}

export default Layout;